import { CardLogin } from "@/components/Cards";
import { CollapseLog } from "@/components/Form/collapseLog";
import { Logo } from "@/components/Header/Logo";
import { SEO } from "@/components/SEO";
import { useAuth } from "@/contexts/AuthContext";
import { useLoading } from "@/contexts/LoadingContext";
import { Layout } from "@/layout";
import { InitializeNethone } from "@/lib/nethone-utils/Types/Overloads";
import { ArrowRightIcon } from "@chakra-ui/icons";
import { Flex, Text, useBreakpointValue } from "@chakra-ui/react";
import router from "next/router";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Login() {
  const Auth = useAuth();
  console.log("Auth", Auth);
  const { setActionIsLoading } = useLoading();
  setActionIsLoading(false);
  const IsWide = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  useEffect(() => {
    return () => {
      InitializeNethone({
        allowedFields: ["HeaderFreeSearch", "LoginEmail"],
        secretFields: ["LoginPassword"]
      });
    };
  }, []);

  useEffect(() => {
    if (Auth.isAuthenticated === true) {
      router.push("/");
    }
  }, [Auth]);

  useEffect(() => {
    const timer = setTimeout(() => {
      AOS.init({
        once: true,
        duration: 1500
      });
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <SEO title="Login" description="Login to your account" path="/login">
      <Layout justifyContent="center" mt={["2rem", "10rem"]} w="full" paddingBottom="0">
        <Flex
          w="full"
          direction="column"
          alignItems="center"
          gap={IsWide && "5px"}
          width={["90%", "full"]}
        >
          <Flex data-aos="fade-up" data-aos-delay="100" data-aos-duration="700">
            <CollapseLog startLogin={true} />
          </Flex>
        </Flex>
      </Layout>
    </SEO>
  );
}
